export interface CurrencyStorageAdapter {
  getItem(key: string): Promise<string | null>;
  setItem(key: string, value: string): Promise<void>;
  removeItem?(key: string): Promise<void>;
}

export interface CurrencyServiceAdapterOptions {
  storage?: CurrencyStorageAdapter;
  getLanguage?: () => Promise<string | undefined>;
  getConfigValue?: (key: string) => string | undefined;
}

let storageAdapter: CurrencyStorageAdapter = {
  async getItem() {
    return null;
  },
  async setItem() {
    // no-op
  },
  async removeItem() {
    // no-op
  },
};

let languageProvider: () => Promise<string | undefined> = async () => undefined;

let configProvider: (key: string) => string | undefined = () => undefined;

export const registerCurrencyServiceAdapters = (options: CurrencyServiceAdapterOptions): void => {
  if (options.storage) {
    storageAdapter = options.storage;
  }
  if (options.getLanguage) {
    languageProvider = options.getLanguage;
  }
  if (options.getConfigValue) {
    configProvider = options.getConfigValue;
  }
};

export const currencyStorage = {
  getItem: (key: string) => storageAdapter.getItem(key),
  setItem: (key: string, value: string) => storageAdapter.setItem(key, value),
  removeItem: (key: string) => storageAdapter.removeItem ? storageAdapter.removeItem(key) : Promise.resolve(),
};

export const getCurrencyServiceLanguage = (): Promise<string | undefined> => languageProvider();

export const getCurrencyServiceConfigValue = (key: string): string | undefined => configProvider(key);
